import { useCallback, useEffect, useState } from 'react';
import { useLocalStorage } from 'src/hooks/use-local-storage';
import { LOCAL_STORAGE_KEYS } from 'src/utils/constant';
import { useTableContext } from '../table/context';

export default function useBasket() {
  const { setTableValue } = useTableContext();

  const [bookInStorage, setBookInStorage] = useLocalStorage(LOCAL_STORAGE_KEYS.GUEST_BASKET, []);
  const [baskets, setBaskets] = useState<any>([]);

  useEffect(() => {
    setTableValue('table_data', bookInStorage);
  }, [bookInStorage]);

  //  resest value
  const resetBaskets = useCallback(() => {
    setTableValue('table_data', null);
    setBaskets([]);
  }, [setBaskets, setTableValue]);

  const removeFromBasket = useCallback(
    (id: string | number) => {
      const newBookInStorage: any = [];
      const newBasket = baskets.filter((book: any) => {
        const isIncluded = +id === +book.id;
        if (!isIncluded) newBookInStorage.push(book.id);

        return !isIncluded;
      });
      setBaskets(newBasket);
      setBookInStorage(newBookInStorage);
    },
    [baskets, setBookInStorage]
  );

  const removeManyFromBasket = useCallback(
    (ids: string[] | number[]) => {
      const newBookInStorage: any = [];
      const newBasket = baskets.filter((book: any) => {
        const isIncluded = ids.some((id) => +id === +book.id);
        if (!isIncluded) newBookInStorage.push(book.id);

        return !isIncluded;
      });
      setBaskets(newBasket);
      setBookInStorage(newBookInStorage);
    },
    [baskets]
  );
  const handleRemoveNotFoundBooks = useCallback(() => {
    if (baskets.length && bookInStorage.length) {
      const newBookInStorage: any = [];

      baskets.forEach((book: any) => {
        if (bookInStorage.includes(book.id)) newBookInStorage.push(book.id);
      });

      setBookInStorage(newBookInStorage);
    }
  }, [bookInStorage, baskets]);
  const toBasket = useCallback(
    (id: string | number) => {
      const newBasket = [...baskets, { id }];
      const newBookInStorage = [...bookInStorage, id];
      // console.log(baskets, newBasket);
      setBaskets(newBasket);
      setBookInStorage(newBookInStorage);
    },
    [baskets, setBookInStorage]
  );

  return {
    bookInStorage,
    setBookInStorage,
    baskets,
    setBaskets,
    toBasket,
    removeFromBasket,
    removeManyFromBasket,
    handleRemoveNotFoundBooks,
    resetBaskets,
  };
}
